var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{
    'sidebar-link': true,
    'is-current': _vm.isCurrent,
    'is-disabled': _vm.disabled
  },attrs:{"href":_vm.href || '#',"target":_vm.external ? '_blank' : null,"rel":_vm.external ? 'noopener' : null},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-fa-circle-notch el-icon-fa-spin"}):_c('i',{class:("" + _vm.icon)}),_vm._v("\n\n  "+_vm._s(_vm.text)+"\n\n  "),_c('transition',{attrs:{"name":"fade"}},[(_vm.badgeText)?_c('sup',{class:{
        count: true,
        'is-warning': _vm.badgeType === 'warning',
        'is-success': _vm.badgeType === 'success',
        'is-primary': _vm.badgeType === 'primary'
      }},[_vm._v("\n      "+_vm._s(_vm.badgeText)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }